<template>
    <div id="loginModal">
         <div class="modal shoppingCartLoginModal" id="myModal">
            <div class="modal-dialog modal-lg">
               <div class="modal-content">
                  <button type="button" class="close" @click="closeModal()" style="padding:10px"><small>Close &times;</small></button>
<div class="loginForm">
                
                    <div class="sec-title">
                        <h2>Account Login</h2>
                        <div class="separate"></div>
                    </div>

                    <div class="tab-content" id="myTabContent">
                        <div class="tab-pane fade show active" id="home" role="tabpanel" aria-labelledby="home-tab">
      
                            <!--Login Form-->
                            <div class="styled-form login-form">
                                <form method="POST" action="/login" name="LOGIN">
                                    <input type="hidden" name="LOGIN" value="1">
                                    <input type="hidden" name="CSRFToken" value="">
                                    <input type="hidden" name="page" :value="scriptName">
                                    <input type="hidden" name="openCart" value="1">                     
                                    <input type="hidden" name="lang" value="en">

                                    <div class="form-group">

                                        <input type="text" name="USER" value="" placeholder="Enter your username *" required="">
                                    </div>
                                    <div class="form-group">

                                        <span id="showHidePasswordBtn" class="adon-icon show-hide-password-btn" @click="showHidePassword()"><i class="fas fa-eye-slash"></i></span>

                                        <input type="password" id="password" name="PASS" value="" placeholder="Enter Password">
                                    </div>
                                    <div class="submit-btn-container">
                                        <div class="form-group pull-left">
                                            <button type="submit" value="login" class="theme-btn btn-style-three"><span class="txt">Login Now</span></button>
                                        </div>
                                        <div class="form-group  pull-right">
                                            <a href="/loginHelp" class="sign-help">Sign in help</a>
                                        </div>
                                    </div>
                                        
                                </form>
                            </div>
                        </div>

                    </div>
                </div>
               </div>
            </div>
         </div>
    </div>
</template>


<script>
    export default {
        props: {
           scriptName: String
           },
        methods: {
           closeModal() {
              this.$emit('modal-closed')
           },
        
           showHidePassword() {
            var showHidePasswordBtn = document.getElementById('showHidePasswordBtn');
            var passwordInput = document.getElementById('password');
            if (passwordInput.type === "password") {
                passwordInput.type = "text";

                showHidePasswordBtn.innerHTML = '<i class="fas fa-eye"></i>';
            } else {
                passwordInput.type = "password";

                showHidePasswordBtn.innerHTML = '<i class="fas fa-eye-slash"></i>';
            }
        }
        },
        created: function () {
           console.log("login modal is open")
        },
   }
</script>

